import React, {ReactElement, useState} from "react";
import classes from './Questions.module.scss'
import {Question} from "./Question";
import ReactGA from 'react-ga'

const Questions = (): ReactElement => {
	const [expandedIndex, setExpandedIndex] = useState(-1)

	const changeExpand = (index: number) => {
		setExpandedIndex(exIdx => exIdx === index ? -1 : index)
		if(expandedIndex !== index) {
			ReactGA.event({
				category: 'User',
				action: 'Open question',
				value: index
			})
		}
	}

	return (
		<div className={classes.root}>
			<h2>Dodatečné informace</h2>
			<Question
				onClick={() => changeExpand(0)}
				expanded={expandedIndex === 0}
				title="Proč volit právě mé služby?"
				body='U mých služeb vždy dbám na kvalitu a na termíny doručení. U každé mé zakázky píšu kvalitní kód, hlídám si bezpečnost a stabilitu všech služeb, které poskytuji'/>
			<Question
				onClick={() => changeExpand(1)}
				expanded={expandedIndex === 1}
				title="Proč chytrá domácnost na míru když si můžu koupit chytré zařizení v obchodě?"
				body='Většina "chytrých" zařízení ve skutečnosti nejsou chytré, protože nedokáží reagovat samy na změny ve svém prostředí.
				Díky mému systému jsem schopen nastavit zařízení aby fungovaly samy od sebe.
				Jeden z příkladů chytrého zařízení je stínící technika, která automaticky reaguje na intenzitu venkovního ovětlení.'/>
			<Question
				title='Jaké jsou ceny mých služeb?'
				expanded={expandedIndex === 2}
				onClick={() => changeExpand(2)}
				body='Ceny nezle říci takhle naslepo dopředu. Všechny ceny se odvíjí od velikosti a komplexity zakázky.
				Stačí vyplnit kontaktní formulář níže, domluvit si schůzku a dohodneme se na ceně, která bude vyhovovat oběma stranám.'
			/>
		</div>
	)
}

export default Questions